import { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "../src/components/theme/theme-color.css";
import { Login } from "./security/login/login";
import { BrowserRouter } from "react-router-dom";
import { CacheService } from "./shared/services/cache.service";
import { connect } from "react-redux";
import { WorkArea } from "./components/workspace/workarea";
import Spinner from "./components/spinner/spinner";
import { AuthenticateService } from "./security/login/authenticate.service";

class AppComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentWillReceiveProps() {
    await this.initialize(this.props);
  }

  async componentDidMount() {
    await this.initialize(this.props);
  }

  async initialize(props) {
    let token = CacheService.get("security", "token");
    if (!token || token === "") {
      token = CacheService.getFromSession("security", "token");
    }
    let authenticated = false;
    if (token) {
      try {
        CacheService.putIntoSession("security", "token", token);
        const user = await AuthenticateService.refreshUser();
        authenticated = user != null;
      } catch (e) {
        authenticated = false;
        CacheService.putIntoSession("security", "token", null);
        CacheService.put("security", "token", null);
      }
    }
    this.setState({ authenticated, initialized: true });
  }

  render() {
    let content;

    if (!this.state.initialized) {
      content = <Spinner></Spinner>;
    } else if (!this.state.authenticated) {
      content = (
        <div>
          <Spinner></Spinner>
          <Login></Login>
        </div>
      );
    } else {
      content = (
        <div>
          <Spinner></Spinner>
          <WorkArea></WorkArea>
        </div>
      );
    }

    return <BrowserRouter>{content}</BrowserRouter>;
  }

  static properties = (state) => {
    return {
      authenticated: state.app.authenticated,
    };
  };

  static dispatchers = (dispatch) => {
    return {};
  };
}

export default connect(
  AppComponent.properties,
  AppComponent.dispatchers,
)(AppComponent);
